import React from 'react'
import { useRef } from 'react';
import './Main.css';
import Footer from './components/Footer';
import Carousel from './components/Carousel';
// import "antd/dist/reset.css";
import { Button, Input, Select, Space } from 'antd';
import Headers from './components/Headers';
import CustomCarousel from './components/CustomCarousel';
import EmailForm from './components/EmailForm';
import { HelmetProvider } from 'react-helmet-async';

export default function Main() {
    // Create refs for each section
    const homeRef = useRef(null);
    const featuresRef = useRef(null);
    const testimonialRef = useRef(null);
    const contactRef = useRef(null);

    // Function to handle smooth scrolling
    const scrollToSection = (elementRef) => {
        elementRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    return (
        <div>
            <HelmetProvider >
                <title>Quran App - Read, Learn & Listen to the Holy Quran | Quran Point</title>
                <meta name="description" content="Quran Point is a beautifully designed Quran app that lets you read, learn, and listen to the Holy Quran in an intuitive way. Download now on Android and iOS." />
                <meta name="keywords" content="Quran app, Quran online, Holy Quran, read Quran, Quran translation, Quran Android, Quran iOS, Islamic app, SkyRaan Technologies" />
                <meta property="og:title" content="Quran App by SkyRaan Technologies" />
                <meta property="og:description" content="Read, learn, and listen to the Holy Quran with the Quran Point app. Available on App Store and Google Play." />
                <meta property="og:image" content="https://yourdomain.com/path-to-thumbnail.jpg" />
                <meta property="og:url" content="https://quranpoint.com" />
                <meta property="og:type" content="website" />


            </HelmetProvider>
            <Headers
                scrollToHome={() => scrollToSection(homeRef)}
                scrollToFeatures={() => scrollToSection(featuresRef)}
                scrollToTestimonial={() => { scrollToSection(testimonialRef) }}
                scrollToContact={() => { scrollToSection(contactRef) }}
            />
            <div className='pb-8  md:pb-16' ref={homeRef} style={{ backgroundColor: "#0A160D" }}>
                <div className='marginClass'>

                    <h1 className='text-center pt-16 lg:pt-32 mb-5'>
                        Your Gateway to Understanding the Quran
                    </h1>
                    <p className='text-center md:mx-20 ' style={{ color: "#ffff" }}>
                        Quran App offers an intuitive and user-friendly platform for reading, listening, and understanding the Quran. Access translations, tafsir (exegesis), and audio recitations anytime, anywhere.
                    </p>
                    <div className='flex gap-[3rem] justify-center mt-8'>
                        <a href='https://apps.apple.com/in/app/uzbek-quran/id1143934624' target='blank'>
                            <img src='assets/applestore.svg' className='storebtn' style={{}} />
                        </a>
                        <img src='assets/playstore.svg' className='storebtn' style={{}} />
                    </div>


                    <div className='flex  justify-center my-8  md:my-16 gap-[1rem] p-[30px]'>
                        <div className='flex-col justify-center gap-[20px]  '>
                            <img src='assets/01.webp' className='' />
                            <img src='assets/04.webp' className='mt-[1rem]' />
                        </div>
                        <div className='flex-col justify-center gap-[20px]'>

                            <img src='assets/02.webp' style={{}} />
                            <img src='assets/05.webp' className='mt-[1rem]' />
                        </div>

                        <div className='flex-col justify-center gap-[20px]'>
                            <img src='assets/03.webp' className='' />
                            <img src='assets/06.webp' className='mt-[1rem]' />
                        </div>
                    </div>

                </div>

            </div>
            <div className='flex gap-[2rem]  justify-center' >
                <h2 className='my-14' style={{ textAlign: "center" }} ref={featuresRef}>Take a Look at Our Features</h2>
                <img src='assets/star.svg' className='starsize' />

            </div>
            {/* part -2  */}
            <div className='md:flex  md:gap-[2rem]  lg:gap-[5rem] mb-[5rem]   marginClass ' style={{ alignItems: "center" }} >
                <div className='flex gap-[6rem] part2 ' style={{}} >
                    <CustomCarousel />



                </div>
                <div className='mt-9 md:mt-0'>
                    <h3 className='mb-5' >What We Offer</h3>
                    <p className='' style={{ textAlign: "justify" }}>
                        Explore the Quran in inspiring new ways with Quran Point! Enjoy meaningful videos that bring verses to life through guided visuals and narration. Reflect on divine wisdom with daily Quran quotes and receive personalized Daily Ayah notifications for ongoing inspiration. Beautify your device with high-quality Islamic wallpapers featuring sacred symbols and Quranic themes. Ideal for sharing and inspiring others.
                    </p>

                </div>

            </div>


            <br ref={testimonialRef} />
            <br />
          
            <div className='flex gap-[2rem] justify-center marginClass'>
                <h2 className='my-14 ' style={{ color: "#003C00", textAlign: "center" }}>How Quran App is making a difference</h2>
                <img src='assets/star.svg' className='starsize' />

            </div>

            {/* part -3 */}




            <div className='marginClass' >
                <Carousel />
            </div>
           
            <br ref={contactRef} />
            <br />
          
           


            {/* part -4 */}

            <div className='marginClass  ' >
                <div className='flex gap-[3rem] justify-center items-center my-10'>
                    <h3> Get in Touch with Us</h3>
                    <img src='assets/star.svg' className='starsize' />
                </div>

                <div className='mt-8 md:grid grid-cols-2 gap-[5rem]'>
                    <div className='mb-5 md:mb-0'>
                        <p>
                            We’re here to help! Have a question or need assistance? Feel free to reach out for any queries or to share your thoughts.
                        </p>

                    </div>
                    <div className='contactus' style={{}} >
                        {/* <textarea placeholder='Your message' id='message' className='textArea' style={{}}>

            </textarea>

            <Space.Compact className='mt-5 ' style={{ width: "100%" }}>
              <Input placeholder='Your email' id='email_id'  />
              <Button className='btnsend' type="submit">Send</Button>
            </Space.Compact> */}

                        <EmailForm />

                    </div>
                </div>
            </div>

            <Footer />

        </div>
    )
}
